export enum OptionTypes {
  Text = 1,
  TrueFalse = 2,
  DropDownList = 3,
  CheckBoxList = 4,
  RadioButtonList = 5,
  TextMultipleLines = 6,
}
